<template>
  <div id="classDetailsDiv">
    <div class="classDetailsDiv_content">
      <div class="head_title class_head_title">
        <div class="head_title_font class_head_title_font">班级资源</div>
      </div>
      <div class="body_content class_body_content">
        <!-- 按钮触发模态框 -->
        <div v-if="classStatus == -1"></div>
        <button v-else-if="classInfoEditFlag==1" type="button" class="btn btn-default btn_option uploadBtn" data-toggle="modal" data-target="#myModal">上传资源</button>
        <!-- 模态框（Modal） -->
        <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" data-backdrop='static'>
          <div class="modal-dialog" style="width: 600px">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                  &times;
                </button>
                <h4 class="modal-title" id="myModalLabel">
                  上传资源
                </h4>
              </div>
              <div class="modal-body">
                <!--上传-->
                <uploader :options="upload.options" :file-status-text="upload.statusText" class="uploader-example" ref="uploader">
                  <uploader-unsupport></uploader-unsupport>
                  <uploader-drop>
                    <p>拖拽文件至此处</p>
                    <uploader-btn :attrs="upload.attrs.video">选择视频</uploader-btn>
                    <uploader-btn :attrs="upload.attrs.image">选择图片</uploader-btn>
                    <uploader-btn :attrs="upload.attrs.file">选择文件</uploader-btn>
                  </uploader-drop>
                  <uploader-list></uploader-list>
                </uploader>
                <!--<button class="btn btn-primary" @click="saveFileList">保存文件</button>-->
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-default btn_save" @click="saveUpload()">
                  保存
                </button>
                <button type="button" class="btn btn-default btn_cancel" data-dismiss="modal">
                  取消
                </button>
              </div>
            </div><!-- /.modal-content -->
          </div><!-- /.modal -->
        </div>

        <!--图片显示-->
        <div class="modal fade" id="myModal_showAllImages" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_showAllImages" aria-hidden="true" data-backdrop='static'>
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                  &times;
                </button>
                <h4 class="modal-title" id="myModalLabel_showAllImages">
                  图片预览
                </h4>
              </div>
              <div class="modal-body">
                <img :src="imageSrc" class="previewImg"/>
              </div>
            </div>
          </div>
        </div>

        <!--视频显示-->
        <div class="modal fade" id="myModal_showVideo" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_showVideo" aria-hidden="true" data-backdrop='static'>
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                  &times;
                </button>
                <h4 class="modal-title" id="myModalLabel_showVideo">
                  视频预览
                </h4>
              </div>
              <div class="modal-body">
                <video class="showVideo video-js" :src="videoSrc" :type="videoType" controls="controls" controlslist="nodownload" autoplay="autoplay" loop="loop" :poster="videoThumbSrc">
                </video>
              </div>
            </div>
          </div>
        </div>

        <!--文档显示-->
        <div class="modal fade" id="myModal_showFile" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_showFile" aria-hidden="true" data-backdrop='static'>
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                  &times;
                </button>
                <h4 class="modal-title" id="myModalLabel_showFile">
                  文档预览
                </h4>
              </div>
              <div class="modal-body">
                <iframe :src="fileSrc" width="100%" height="700px"></iframe>
              </div>
            </div>
          </div>
        </div>


        <div class="res_div" v-if="classStatus != -1">
          <div class="videoDiv">
            <div v-for="(res,index) in resourcesList" :key="index" class="videoImgPath" @click="openVideoModal(res.mimeType, res.filePath)">
              <span class="delete_res_div" @click.stop @click="delete_res_id=res.id;delete_res()">
                <img src="../assets/img/right/clazz/delete_mouseOver.png"/>
              </span>
              <!--<img :src="res.mimeType,res.filePath | format_thumbSrc"/>-->
              <img v-if="res.mimeType.indexOf('image') != -1" :src="imgThumbSrc + res.filePath"/>
              <img v-else-if="res.mimeType.indexOf('video') != -1" src="../assets/img/back_bg/ht_sp_1.png"/>
              <img v-else-if="res.mimeType.indexOf('application/pdf') != -1" src="../assets/img/back_bg/ht_pdf_1.png"/>
              <img v-else src="../assets/img/back_bg/ht_word_1.png"/>
              <div class="tabTd_content_ellipsis" :title="res.fileName">{{res.fileName}}</div>
            </div>
          </div>
        </div>

        <div class="res_div" v-else>
          <div class="videoDiv">
            <div v-for="(res,index) in resourcesList" :key="index" class="videoImgPath" @click="openVideoModal(res.mimeType, res.filePath)">
              <img v-if="res.mimeType.indexOf('image') != -1" :src="imgThumbSrc + res.filePath"/>
              <img v-else-if="res.mimeType.indexOf('video') != -1" src="../assets/img/back_bg/ht_sp_1.png"/>
              <img v-else-if="res.mimeType.indexOf('application/pdf') != -1" src="../assets/img/back_bg/ht_pdf_1.png"/>
              <img v-else src="../assets/img/back_bg/ht_word_1.png"/>
              <div class="tabTd_content_ellipsis" :title="res.fileName">{{res.fileName}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {schoolAxios} from "../main";
  import {getContentSize} from './mainView';

  export default {
    name: "classResources",
    data() {
      return {
        clazzId: this.$store.state.clazzId,
        publishStatus: this.$store.state.publishStatus,
        classStatus: this.$store.state.classStatus,
        //是否可编辑flag
        classInfoEditFlag:this.$store.state.classInfoEditFlag,

        //资源列表
        resourcesList: [],

        delete_res_id: '',

        //图片
        imgThumbSrc: this.$store.state.serviceBase + "resources/",
        imageSrc: '',

        //视频
        videoSrc: '',
        videoThumbSrc: '',
        videoType: 'video/mp4',

        //文档
        fileThumbSrc: '',
        fileSrc: '',

        thumbSrc: '',

        //上传
        uploadIds: '',
        upload: {
          uploader: null,
          options: {
            target: this.$store.state.serviceBase + 'upload/chunkUpload.action',
            maxChunkRetries: 3,
            method: 'post',
            headers: {
              'Authorization': this.$store.state.token_type + " " + this.$store.state.access_token
            },
            query: {
              attachmentType: 'zy'
            },
            simultaneousUploads: 1,//同时上传数
            testChunks: false,
            chunkSize: 1024*1024,//分片大小：10G
          },
          attrs: {
            file: {
              accept: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,application/pdf'
            },
            image: {
              accept: 'image/*'
            },
            video: {
              accept: 'video/*'
            },
          },
          statusText: {
            success: '成功了',
            error: '出错了',
            uploading: '上传中',
            paused: '暂停中',
            waiting: '等待中',
          },
        },
      }
    },
    filters: {
      format_thumbSrc(type, path){
        let this_ = this;
        if(type.indexOf("image") != -1){
          //图片
          return "";//http://192.168.1.30" + ":8769/school/resources/" + path;
        }else if(type.indexOf("video") != -1){
          //视频
          return "";
        }else if(type.indexOf("application/pdf") != -1){
          //PDF
          return "";
        }else{
          //Word
          return "";
        }
      }
    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();

        //绑定加载关闭模态框时的事件
        this_.closeModal();

        //获得上传组件对象
        this_.upload.uploader = this_.$refs.uploader.uploader;
        //上传组件绑定事件
        this_.loadUpload();

        this_.initClassResourcesData();
      });
    },
    methods: {
      /**
       * 初始加载数据
       */
      initClassResourcesData(){
        let this_= this;
        schoolAxios({
          method: 'get',
          url: 'upload/list.action',
          params: {
            'attachmentType': 'zy',
            'formObjId': this_.clazzId
          }
        }).then(function (resp) {
          let data = resp.data;
          if(data.success){
            this_.resourcesList = data.list;
          }
        });
      },
      /**
       * 删除资源
       */
      delete_res(){
        let this_ =this;
        "确定删除资源".showConfirm(function () {
          schoolAxios({
            method: 'delete',
            url: 'upload/delete.action',
            params: {
              uploadAttachmentId: this_.delete_res_id
            }
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              "删除成功".showMessage();
              this_.initClassResourcesData();
            }else{
              "删除失败".showMessage();
            }
          })
        })
      },
      /**
       * 打开预览模态框
       */
      openVideoModal(type, filePath) {
        let this_ = this;
        if(type.indexOf("video")!=-1){
          this_.videoSrc = this_.$store.state.serviceBase + "resources/" + filePath;
          $("#myModal_showVideo").modal("show");
        }else if(type.indexOf("image")!=-1){
          this_.imageSrc = this_.$store.state.serviceBase + "resources/" + filePath;
          $("#myModal_showAllImages").modal("show");
        }else {
          let data = filePath.substring(0, 11);
          let fileId = filePath.substring(11, filePath.indexOf('.'));
          let pdf = filePath.substring(filePath.lastIndexOf("."), filePath.length);
          if(pdf && pdf.toLowerCase().includes("pdf")){
            this_.fileSrc = this_.$store.state.serviceBase + "resources/" + filePath;
          }else{
            this_.fileSrc = this_.$store.state.serviceBase + "resources/" + data + fileId + "_file/" + fileId + ".html";
          }
          $("#myModal_showFile").modal("show");
        }
      },
      /**
       * 关闭模态框监听
       */
      closeModal() {
        let this_ = this;
        $('#myModal_showVideo').on('hide.bs.modal', function () {
          this_.videoSrc = "";
        });

        $("#myModal").on('hide.bs.modal', function () {
          this_.uploadIds = "";
          this_.upload.uploader.cancel();
        });
      },
      /**
       * 保存上传
       */
      saveUpload(){
        let this_= this;
        if(this_.uploadIds != ""){
          schoolAxios({
            method: 'post',
            url: 'upload/relation.action',
            data: {
              'uploadAttachmentIds': this_.uploadIds,
              'formObjId': this_.clazzId
            }
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              "保存成功".showMessage();

              $("#myModal").modal('hide');
              this_.initClassResourcesData();
            }else{
              "保存失败".showMessage();
            }
          });
        }
      },
      /**
       * 上传加载
       */
      loadUpload(){
        let this_ = this;
        this_.upload.uploader.on('fileAdded', function (file, event) {
          if(file.fileType.indexOf("video")==-1 && file.fileType.indexOf("image")==-1 && this_.upload.attrs.file.accept.indexOf(file.fileType)==-1){
            (file.name+"不是所需格式文件，请重新选择正确的格式文件上传").showMessage();
            return false;
          }
        })
        this_.upload.uploader.on('fileSuccess', function (rootFile, file, message, chunk) {
          //console.info(message);
          if(message){
            let message_ = JSON.parse(message);
            //console.info(message_);
            if(this_.uploadIds != ""){
              this_.uploadIds += ",";
            }
            this_.uploadIds += message_.message;
          }
        })
        this_.upload.uploader.on('fileComplete', function (rootFile) {
          //console.info(rootFile);
        })
        this_.upload.uploader.on('fileError', function (rootFile, file, message) {
          (file.name+"上传失败").showMessage();
        })
      },
    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  @import '../assets/css/classResources.css';
</style>



// WEBPACK FOOTER //
// src/components/classResources.vue